import { StandardQuizQuestion } from '@/types/quizTypes';

export const K8S_CLUSTER_ARCHITECTURE_QUIZ: StandardQuizQuestion[] = [
  {
    id: "k8s-arch-1",
    question: "What are the main components of the Kubernetes control plane?",
    options: [
      "Pods and Services",
      "API Server, Scheduler, Controller Manager, and etcd",
      "Kubelet and Kube-proxy",
      "Docker and containerd"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "The control plane manages the cluster state. API Server is the central management point, Scheduler assigns pods to nodes, Controller Manager maintains desired state, and etcd stores cluster data.",
    category: "control-plane",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "k8s-arch-2",
    question: "What is the role of etcd in Kubernetes?",
    options: [
      "Runs containers",
      "Stores all cluster data as a distributed key-value store",
      "Routes network traffic",
      "Schedules pods"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "etcd is a distributed, consistent key-value store that holds all cluster configuration and state. It's the single source of truth for the cluster.",
    category: "control-plane",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "k8s-arch-3",
    question: "What does the kubelet do on a worker node?",
    options: [
      "Stores cluster state",
      "Manages containers and ensures pods are running",
      "Routes external traffic",
      "Balances load across nodes"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Kubelet is an agent that runs on each node, managing containers via the container runtime and ensuring pods match their spec from the API server.",
    category: "worker-nodes",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "k8s-arch-4",
    question: "What is the purpose of kube-proxy?",
    options: [
      "API authentication",
      "Network proxy maintaining network rules for pod communication",
      "Pod scheduling",
      "Container runtime"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Kube-proxy maintains network rules on nodes, enabling pod-to-pod and service-to-pod communication across the cluster using iptables or IPVS.",
    category: "networking",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "k8s-arch-5",
    question: "What does the Kubernetes Scheduler do?",
    options: [
      "Deletes old pods",
      "Assigns pods to nodes based on resource requirements and constraints",
      "Creates new namespaces",
      "Updates container images"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "The Scheduler watches for newly created pods without assigned nodes and selects appropriate nodes based on resource availability, affinity rules, and constraints.",
    category: "control-plane",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "k8s-arch-6",
    question: "What are the main phases of a pod's lifecycle?",
    options: [
      "Start, Run, Stop",
      "Pending, Running, Succeeded/Failed, Unknown",
      "Created, Active, Terminated",
      "Init, Ready, Complete"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "Pod phases: Pending (accepted but not running), Running (bound to node with at least one container running), Succeeded (all containers terminated successfully), Failed (terminated with errors), Unknown (state unknown).",
    category: "pods",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "k8s-arch-7",
    question: "What is the smallest deployable unit in Kubernetes?",
    options: [
      "Container",
      "Pod",
      "Node",
      "Service"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "A Pod is the smallest deployable unit. It can contain one or more containers that share storage, network, and specifications for how to run the containers.",
    category: "pods",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "k8s-arch-8",
    question: "What is the role of the Controller Manager?",
    options: [
      "Manages user authentication",
      "Runs controller processes that regulate cluster state",
      "Stores logs",
      "Monitors network traffic"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "Controller Manager runs various controllers (Node, Replication, Endpoints, Service Account) that watch cluster state and make changes to move current state toward desired state.",
    category: "control-plane",
    points: 20,
    type: "multiple-choice"
  }
];

export const generateK8sClusterArchitectureQuiz = () => ({
  questions: K8S_CLUSTER_ARCHITECTURE_QUIZ,
  passThreshold: 75,
  timeLimit: 900,
  category: 'kubernetes-architecture'
});
